// widgets/QuickStats.jsx
import React, { useEffect, useState } from 'react';
import { api } from '../scripts/api'; // Assuming api is your axios/fetch wrapper
import { AlertCircle, Boxes, DollarSign, Truck } from 'lucide-react';
import '../App.css';
import './Widgets.css';

export default function QuickStats() {
  const [stats, setStats] = useState({
    total: 0,
    alerts: 0,
    stock: 0,
    demo: 0,
    rental: 0,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { data } = await api.get('/reports/summary', {
          params: { table: 'all_inventory' }, // Adjust table if needed
        });
        setStats({
          total: data.total || 0,
          alerts: data.flags?.alerts || 0,
          stock: data.flags?.is_stock || 0,
          demo: data.flags?.is_demo || 0,
          rental: data.flags?.is_rental || 0,
        });
      } catch (e) {
        setError(e?.response?.data?.error || 'Failed to load stats');
      } finally {
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) return <div className="widget-loading">Loading stats...</div>;
  if (error) return <div className="widget-error">{error}</div>;

  return (
    <div className="widget quick-stats">
      <h3 className="widget-title">Inventory Quick Stats</h3>
      <div className="stats-grid">
        <div className="stat-item">
          <Boxes size={24} />
          <div>
            <div className="stat-value">{stats.total}</div>
            <div className="stat-label">Total Units</div>
          </div>
        </div>
        <div className="stat-item">
          <AlertCircle size={24} />
          <div>
            <div className="stat-value">{stats.alerts}</div>
            <div className="stat-label">Alerts</div>
          </div>
        </div>
        <div className="stat-item">
          <Truck size={24} />
          <div>
            <div className="stat-value">{stats.stock}</div>
            <div className="stat-label">In Stock</div>
          </div>
        </div>
        <div className="stat-item">
          <DollarSign size={24} />
          <div>
            <div className="stat-value">{stats.rental}</div>
            <div className="stat-label">Rentals</div>
          </div>
        </div>
        <div className="stat-item">
          <Boxes size={24} />
          <div>
            <div className="stat-value">{stats.demo}</div>
            <div className="stat-label">Demos</div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Example CSS (add to your stylesheet)
